import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { getErrorText } from 'src/app/service/ansokan-form-builder/validator-errors';

@Component({
    selector: 'app-checkbox',
    styleUrls: ['./checkbox.component.scss'],
    templateUrl: './checkbox.component.html',
    standalone: false
})
export class CheckboxComponent implements OnInit {

  private static ID = 0;

  @Input() public control: UntypedFormControl;
  public localGroup: UntypedFormGroup;
  public uniqueId: number;

  public get error(): string {
    return getErrorText(this.control);
  }

  constructor(private fb: UntypedFormBuilder) {
    this.uniqueId = ++CheckboxComponent.ID;
   }

  public ngOnInit() {
    this.localGroup = this.fb.group({ control: this.control });
  }

}
